import {
  Modal,
} from 'antd';
import CrossCircle from 'Components/common/assets/svgIcons/CrossCircle';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { PersonPopupResponse } from 'Types/PersonTypes';
import {
  favouriteArticleColor,
  popupBgLayerV1,
  primaryFont, SecondaryColorTwo, wLight, wMBold, wMedium,
} from 'Utils/utilsStyle';

const Paragraph = styled.p`
  font-weight: ${wLight};
  font-family: ${primaryFont};
  color: ${SecondaryColorTwo};
  margin-top:15px;
  font-size: 16px;
  letter-spacing: -0.44px;
  line-height: 24px;
`;
const Wrapper = styled.div`
  text-align: center;
  padding: 80px 47px 48px 47px;
  background-image: url(${popupBgLayerV1});
  background-position:center;
  background-size:cover;
`;
const Heading = styled.h1`
  font-weight: ${wMedium};
  font-family: ${primaryFont};
  color: ${SecondaryColorTwo};
  font-size: 42px;
  line-height: 42px;
  letter-spacing: -1.17px;
  margin:0px;
  margin-bottom:48px;
`;
const Button = styled.span`
  font-size: 16px;
  font-weight: ${wMBold};
  color: #ffffff;
  background-color: ${favouriteArticleColor};
  border: none;
  border-radius: 17px;
  padding: 6px 22px 6px 22px;
  cursor:pointer;
`;

type Props = {
  popupResponse: PersonPopupResponse,
};

const LimitReached = function LimitReached(props: Props) {
  const { popupResponse } = props;
  const navigate = useNavigate();
  return (
    <Modal
      open
      centered
      closeIcon={<CrossCircle />}
      onCancel={() => navigate(-1)}
      width="632px"
      wrapClassName="modal-guest"
    >
      <Wrapper>
        <Heading>{popupResponse?.popupHeading}</Heading>
        <Button
          onClick={() => window.open(popupResponse?.callToAction)}
          onKeyPress={() => window.open(popupResponse?.callToAction)}
        >
          {popupResponse?.buttonText || 'Schedule a demo'}
        </Button>
        <Paragraph>{popupResponse?.popupText}</Paragraph>
      </Wrapper>
    </Modal>
  );
};

export default LimitReached;
